export enum RingingStrategy {
  Unknown = 'Unknown',
  RingAll = 'RingAll',
  Random = 'Random',
  LeastRecent = 'LeastRecent',
  FewestCalls = 'FewestCalls',
}
